import { useMutation } from "react-query";
import { getInvoiceBy } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useSearchPending = () => {
  return useMutation(getInvoiceBy);
};
export default useSearchPending;
